module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_22abril.4812f430.jpg";